import { Button } from '@trackman/web-shared-components';
import { ServiceTypes } from 'constants/ServiceTypes';
import { History } from 'history';
import { observer } from 'mobx-react-lite';
import { SessionReviewRowManager } from 'models/review/SessionReviewRowManager';
import React from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { GameReviewStore } from 'stores/GameReviewStore';
import { Controls, Errors, StyledButton, StyledModal, SubmitModalFooter } from './SubmitModalStyles';

interface IProps {
  history: History;
  id: string;
  errorCount: number;
  rowManager: SessionReviewRowManager;
  onSubmit: () => void;
}

const SubmitModal: React.FC<IProps> = observer((props) => {
  const { history, id, errorCount, rowManager, onSubmit } = props;
  const reviewStore = useInjection<GameReviewStore>(ServiceTypes.GameReviewStore);
  const handleOnDismiss = (): void => {
    reviewStore.setIsSubmitModalVisible(false);
  };

  return (
    <StyledModal open={reviewStore.isSubmitModalVisible} onClose={handleOnDismiss} title='submit game'>
      <Errors>
        {errorCount >= 1
          ? `${errorCount} error${errorCount > 1 ? 's' : ''}  still present. Are you sure you want to submit the game?`
          : 'Submit game?'}
      </Errors>
      <SubmitModalFooter>
        <Controls>
          <Button intent='primary' label='Cancel' onClick={handleOnDismiss} width='110px' />
          <StyledButton intent='primary' label='submit' onClick={onSubmit} width='112px' data-test='submit-session-modal-button' />
        </Controls>
      </SubmitModalFooter>
    </StyledModal>
  );
});

export default SubmitModal;
